<template>
  <div class="itinerary-box bg-dirty-blue print-no-overlap rounded-lg flex flex-col md:flex-row">
    <div
      v-if="hasIcon"
      class="itinerary-box-icon flex flex-row grow print-hidden itinerary-box-icon-color pt-4 md:py-6 text-blue-700 items-start px-4 md:px-0"
    >
      <fa
        v-if="boxType === boxTypes.hotel"
        class="min-h-[25px]"
        icon="hotel"
      />
      <fa
        v-if="boxType === boxTypes.excursions"
        class="min-h-[25px]"
        icon="archway"
      />
    </div>

    <ItineraryContent
      class="ml-0 p-4"
      :class="hasIcon ? 'md:pl-0' : 'md:px-6'"
      :is-destination="isDestination"
      :itinerary-day="itineraryDay"
      color="transparent"
      :allow-fullscreen="allowFullscreen"
      :allow-open-map="allowOpenMap"
      :slider-navigation="sliderNavigation"
      :text-class="textClass"
    />
  </div>
</template>

<script>
import FaSharpSolidCircleInfoSVG from '@fortawesome/fontawesome-pro/svgs/sharp-solid/circle-info.svg'

import { boxTypes } from '@packages/trip/constants/types.ts'

export default defineNuxtComponent({
  components: {
    FaSharpSolidCircleInfoSVG,
  },

  props: {
    itineraryDay: {
      type: Object,
      default: () => ({}),
    },

    boxType: {
      type: String,
      default: 'day',
    },

    isDestination: {
      type: Boolean,
      default: false,
    },

    allowFullscreen: {
      type: Boolean,
      default: true,
    },

    allowOpenMap: {
      type: Boolean,
      default: true,
    },

    sliderNavigation: {
      type: Boolean,
      default: true,
    },

    textClass: {
      type: String,
      default: '',
    },
  },

  data () {
    return {
      boxTypes,
    }
  },

  computed: {
    hasTitle () {
      return this.itineraryDay.title
    },

    hasIcon () {
      return this.boxType !== boxTypes.generalInfo
    },
  },
})
</script>

<style lang="scss">
.itinerary-box {
  .product-itinerary__item-title {
    margin-bottom: 5px !important;

    @media (max-width: calc(theme('screens.md') - 1px)) {
      display: none;
    }
  }

  &-icon {
    &-color {
      min-width: 120px;
      max-width: 120px;

      @media (min-width: theme('screens.md')) {
        svg {
          padding-left: 2rem;
          padding-right: 2rem;
        }
      }
    }

    h5 {
      font-size: 1.25rem;
    }

    svg {
      height: auto;
      width: 100%;

      @media (max-width: calc(theme('screens.md') - 1px)) {
        width: unset;
      }
    }

    @media (max-width: calc(theme('screens.md') - 1px)) {
      min-width: 100%;

      svg {
        width: unset;
        max-height: 50px;
      }
    }
  }
}
</style>
